import { useTranslation } from 'react-i18next';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { useAppSelector } from '../../store/hooks';

export function ProfilePage() {
  const { t } = useTranslation();
  const user = useAppSelector((state) => state.auth.user);
  const webId = useAppSelector((state) => state.auth.webId);

  if (!user) return <p>{t('auth.noUser')}</p>;

  return (
    <div>
      <h2>{t('profile.title')}</h2>
      <Table>
        <TableBody>
          {([
            [t('profile.instance'), webId ?? '—'],
            [t('profile.email'), user.emailAddress],
            [t('profile.name'), user.fullName],
            [t('profile.groups'), user.groups.map((g) => g.name).join(', ')],
          ] as const).map(([label, value]) => (
            <TableRow key={label}>
              <TableCell sx={{ fontWeight: 600, color: 'text.secondary' }}>{label}</TableCell>
              <TableCell>{value}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
